/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/secret';
import { SECRET } from '@/store/types';
import { SecretGroupFilter } from '@/api/types/secret';
import { StoreDataCache, findCache, saveCache } from '@/store/cache';
import { ActionType, StoreActionEnv, finalizeAction } from '@/store/actions';

export interface StoreSecretFilterGroupInfo {
  group: string;
  title: string;
  filters: SecretGroupFilter[];
}

export interface StoreSecretFilterGroupState {
  cache: StoreDataCache<StoreSecretFilterGroupInfo>[];
  maxCache: number;
}

export default {
  namespaced: true,
  state: {
    cache: [],
    maxCache: 20,
  },
  getters: {},
  actions: {
    [SECRET.GET_GROUP_FILTERS](
      { commit, state }: StoreActionEnv<StoreSecretFilterGroupState>,
      { action: rawAction, group }: { action: ActionType; group: string },
    ) {
      const action = finalizeAction(rawAction, findCache(state.cache, group));
      if (action) {
        return new Promise((resolve, reject) => {
          api.getGroupFilters(group).then((res) => {
            commit(SECRET.GET_GROUP_FILTERS, {
              group,
              title: res.extra.title,
              filters: res.data,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [SECRET.GET_GROUP_FILTERS](state, { group, title, filters }) {
      saveCache(state.cache, group, { group, title, filters });
    },
  },
};
